import React from "react";
import { Modal } from "antd";

const AttendanceImagePopupModal = ({ open, images = [], onClose, type }) => {
  const titleMap = {
    attendance: "Attendance Images",
    compliance: "Compliance Images",
    school: "School Visit Photos",
  };

  console.log("Popup images received:", images); // Debug log

  return (
    <Modal
      open={open}
      title={titleMap[type] || "Images"}
      onCancel={onClose}
      footer={null}
      styles={{ body: { padding: "20px" } }}
    >
      <div>
        {Array.isArray(images) && images.length > 0 ? (
          images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`${type} ${index}`}
              style={{ width: "100%", marginBottom: "10px" }}
            />
          ))
        ) : (
          <p>No images available</p>
        )}
      </div>
    </Modal>
  );
};

export default AttendanceImagePopupModal;
